/**
 * Copyright (c) 2010-2022 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { NgModule } from '@angular/core';
import { LogoutModule } from '../logout/logout.module';
import { ResetPasswordModule } from '../password/reset-password.module';
import { UserToolsComponent } from './user-tools.component';

@NgModule({
    exports: [ UserToolsComponent ],
    imports: [ LogoutModule, ResetPasswordModule, UserToolsComponent ]
})
export class UserToolsModule {}
